export default __webpack_public_path__ + "static/media/icon_web.a87b3706.svg";